import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PrimaryLogo, AppIcon } from "@/components/Brand";

export function Header() {
  return (
    <header className="sticky top-0 z-30 backdrop-blur-md" style={{ background: "rgba(255,255,255,0.92)", borderBottom: "1px solid #E2E8F0" }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center" aria-label="Pathways to Purpose home">
          {/* Mobile: icon-only mark (48–64 px). Desktop: full primary logo (≤220 px). */}
          <span className="sm:hidden">
            <AppIcon size={56} />
          </span>
          <span className="hidden sm:block">
            <PrimaryLogo maxWidth={220} />
          </span>
        </Link>
        <nav className="flex items-center gap-2 sm:gap-4 text-sm">
          <Link to="/criteria" className="hidden sm:inline" style={{ color: "#475569" }}>Selection criteria</Link>
          <Link to="/accommodation" className="hidden sm:inline" style={{ color: "#475569" }}>Accessibility</Link>
          <Link to="/privacy" className="hidden sm:inline" style={{ color: "#475569" }}>Privacy</Link>
          <Link to="/admin/login" className="p2p-btn-outline" style={{ padding: "0.4rem 1rem" }} data-testid="header-admin-link">Admin</Link>
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  const [prop, setProp] = useState(null);
  useEffect(() => { api.get("/property").then((r) => setProp(r.data)).catch(() => {}); }, []);
  const phone = prop?.contact_phone || "(402) 753-7302";
  const email = prop?.contact_email || "pathwaystopurposehousing@gmail.com";
  const address = prop?.address || "2821 N 55th St, Omaha, NE 68104";
  return (
    <footer className="mt-16 border-t" style={{ borderColor: "#E2E8F0", background: "#F4F8FB" }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 grid sm:grid-cols-3 gap-6 text-sm" style={{ color: "#475569" }}>
        <div>
          <div className="font-serif text-lg mb-2" style={{ color: "#0B2D59" }}>Equal Housing Opportunity</div>
          <p>This housing provider does not discriminate on the basis of race, color, religion, national origin, sex, sexual orientation, gender identity, disability, familial status, or any other federally or state protected characteristic.</p>
        </div>
        <div>
          <div className="font-serif text-lg mb-2" style={{ color: "#0B2D59" }}>Contact</div>
          <a className="flex items-center gap-2 hover:underline" href={`tel:${phone.replace(/[^+\d]/g, "")}`} data-testid="footer-phone"><Phone className="w-4 h-4" /> {phone}</a>
          <a className="flex items-center gap-2 hover:underline" href={`mailto:${email}`} data-testid="footer-email"><Mail className="w-4 h-4" /> {email}</a>
          <div className="flex items-center gap-2"><MapPin className="w-4 h-4" /> {address}</div>
        </div>
        <div>
          <div className="font-serif text-lg mb-2" style={{ color: "#0B2D59" }}>A real person reviews every application.</div>
          <p>AI may help organize information, but a person makes every decision.</p>
        </div>
      </div>
      <div className="text-center text-xs py-4" style={{ color: "#475569" }}>
        © Pathways to Purpose. Built with care.
      </div>
    </footer>
  );
}

export default function Page({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
